import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ProcessStep {
  id: number;
  step: string;
  title: string;
  description: string;
  icon: string;
}

const ProcessSection = () => {
  const processSteps: ProcessStep[] = [
    {
      id: 1,
      step: "Step 1",
      title: "Measure Your Space",
      description: "Input your space dimensions, current setup, and optimization goals using our guided form.",
      icon: "RulerIcon"
    },
    {
      id: 2,
      step: "Step 2", 
      title: "Get AI Recommendations",
      description: "Our AI analyzes your data and generates personalized plans for maximum productivity.",
      icon: "CpuChipIcon"
    },
    {
      id: 3,
      step: "Step 3",
      title: "Customize Your Plan",
      description: "Review, modify, and fine-tune the recommendations to match your preferences.",
      icon: "PencilSquareIcon"
    },
    {
      id: 4,
      step: "Step 4",
      title: "Implement & Track",
      description: "Follow the plan and monitor your progress with built-in tracking tools.",
      icon: "ChartBarIcon"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground">
            Simple 4-Step Process
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From initial assessment to productive implementation, our streamlined process makes space optimization accessible to everyone.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {processSteps.map((step, index) => (
            <div key={step.id} className="relative">
              {/* Connection Line */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-border z-0">
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
                    <Icon name="ChevronRightIcon" size={16} className="text-muted-foreground" />
                  </div>
                </div>
              )}

              <div className="relative z-10 text-center space-y-4">
                <div className="w-24 h-24 bg-primary rounded-full flex items-center justify-center mx-auto shadow-lg">
                  <Icon name={step.icon as any} size={32} className="text-primary-foreground" />
                </div>
                
                <div className="space-y-2">
                  <div className="text-sm font-medium text-accent uppercase tracking-wide">
                    {step.step}
                  </div>
                  <h3 className="text-xl font-heading font-semibold text-foreground">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;